var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-date-picker',{staticClass:"dateInput",attrs:{"type":"date","format":"dd MMM yyyy","placeholder":"Choississez une date"},on:{"input":function($event){return _vm.$emit('model-updated', $event, _vm.schema.model)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }